import { CheckCircleIcon } from '@heroicons/react/solid';

export function FeatureCardsListItem({ detail }) {
    return (
        <li className='flex items-start py-2 text-left'>
            <CheckCircleIcon className='mr-2 mt-1 h-5 w-5 text-avenue-blue-500' />
            <span className='flex-1'>{detail}</span>
        </li>
    );
}
